<template>
	<div class="app">
		<banner title="医院资讯" />
		<div class="app-section" v-loading="loading">
			<div class="app-section-content">
				<div class="content-nav">
					<router-link class="content-nav-btn" :class="{'content-nav-active':articlePart == 1}"
						:to="{ name: 'news', params: { part: 1 }}">
							<span>医疗动态</span>
					</router-link>
					<div class="content-nav-fenGeFu"></div>
					<router-link class="content-nav-btn" :class="{'content-nav-active':articlePart == 2}"
						:to="{ name: 'news', params: { part: 2 }}">
							<span>行业新闻</span>
					</router-link>
					<div class="content-nav-fenGeFu"></div>
					<router-link class="content-nav-btn" :class="{'content-nav-active':articlePart == 3}"
						:to="{ name: 'news', params: { part: 3 }}">
							<span>健康科普</span>
					</router-link>
					<div class="content-nav-fenGeFu"></div>
					<router-link class="content-nav-btn" :class="{'content-nav-active':articlePart == 4}"
						:to="{ name: 'news', params: { part: 4 }}">
							<span>媒体报道</span>
					</router-link>
					<div class="content-nav-fenGeFu"></div>
					<router-link class="content-nav-btn" :class="{'content-nav-active':articlePart == 5}"
						:to="{ name: 'news', params: { part: 5 }}">
							<span>患者之声</span>
					</router-link>
				</div>
				
				<div v-if="articleList.length == 0" class="no-data">
					<div>暂时还没有内容喔~</div>
				</div>

				<div v-else class="content-nav-item">
					<div v-for="(item,index) in articleList" :key="index">
						<div v-if="item.isWechatArticle == 1" class="item-list" @click="goTo(item.url)">
							<div class="item-img" v-lazy:background-image="item.cdnUrl"></div>
							<p class="item-list-title">{{item.title}}</p>
							<p class="item-list-content">{{item.content}}</p>
							<div class="item-list-more">
								<span>{{formatDate(item.createDate)}}</span>
								<div>
									<span>MORE</span>
									<img src="../assets/img/sanjiao.png" />
								</div>
							</div>
						</div>
						<router-link v-else target="_blank" rel="noopener noreferrer" class="text-decoration item-list"
							:to="{ name: 'article', params: { id: item.id }}">
							<div class="item-img" v-lazy:background-image="item.mainImg.src"></div>
							<p class="item-list-title">{{item.title}}</p>
							<p class="item-list-content">{{item.content}}</p>
							<div class="item-list-more">
								<span>{{formatDate(item.createDate)}}</span>
								<div>
									<span>MORE</span>
									<img src="../assets/img/sanjiao.png" />
								</div>
							</div>
						</router-link>
					</div>
				</div>
				
				<!-- 分页条 -->
				<div v-if="pagination.total != 0" class="page-bar">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pagination.currentPage" :page-sizes="pagination.pageSizes"
						:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total">
					</el-pagination>
				</div>

			</div>
		</div>
		<Back2Top></Back2Top>
	</div>
</template>

<script>
	import Banner from "../components/Banner";
	import Back2Top from '../components/Back2Top.vue';
	export default {
		name: "app",
		components: {
			Banner,
			Back2Top,
		},
		data() {
			return {
				loading: true,
				articleList: [],
				articlePart: 1,
				pagination: {
					pageSizes: [6, 12, 24, 48],
					pageSize: 6,
					currentPage: 1,
					total: 0,
				},
			};
		},
		methods: {
			handleSizeChange(val) {
				// window.console.log(`每页 ${val} 条`);
				this.pagination.pageSize = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				// window.console.log(`当前页: ${val}`);
				this.pagination.currentPage = val;
				this.loadData();
			},
			loadData() {
				var data = {
					type: 4,
					part: this.articlePart,
					pageSize: this.pagination.pageSize,
					currentPage: this.pagination.currentPage,
				};
				this.loading = true;
				this.$http
					.post('/article/getListToShowByPage', data)
					.then(response => {
						// console.log(response.data);
						this.articleList = response.data.data.articleList;
						this.pagination.total = response.data.data.total;
						this.loading = false;
						// window.console.log(this.articleListWitMainImg);
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
					});
			},
			goTo(url) {
				window.open(url);
			},
			//时间格式化
			formatDate(isoString) {
				const date = new Date(isoString);
			
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
			
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
		},
		created() {
			this.articlePart = this.$route.params.part;
			// window.console.log(this.pid);
		},
		mounted() {
			// watch已经执行了，不注释的话载入页面时会执行两次
			// this.loadData();
		},
		watch: {
			articlePart() {
				this.loadData();
			}
		},
		beforeRouteUpdate(to, from, next) {
		    this.articlePart = to.params.part; // 更新 articlePart
		    next(); // 必须调用 next()
		    // 可以在这里重新加载数据
		    // this.fetchappData(to.params.type);
		  },
	};
</script>

<style lang="scss" scoped>
	* {
		margin: 0;
		padding: 0;
	}
	
	.no-data {
		display: flex; 
		align-items: center; 
		justify-content: center; 
		margin: 50px 0;
	}
	
	.page-bar {
		display: flex; 
		align-items: center; 
		justify-content: center; 
		margin-top: 30px;
	}

	.app {
		width: 100%;
		height: 100%;
		background-color: #972326;
		position: relative;
		overflow: hidden;

		&-section {
			// width: 100%;
			//height: 1600px;

			&-content {
				width: 70vw;
				min-width: 1240px;
				//height: 1600px;
				margin: 0 auto;
				padding-bottom: 60px;
				background-color: #fff;
				// border: 1px solid #972326;

				.content-nav {
					width: 980px;
					height: 60px;
					margin: 0 auto;
					padding: 30px;
					display: flex;
					//justify-content: center;
					align-items: center;
					// position: relative;
					// bottom: 00px;
					// border: 2px solid #972326;
					border-radius: 10px;
					overflow: hidden;
					font-size: 30px;
					line-height: 60px;
					font-weight: bold;

					&-btn {
						color: #3e3e3e;
						text-decoration: none;
						width: 180px;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						// background-color: #e4e4e4;
						transition: all 0.3s;
					}
					&-btn:hover {
						cursor: pointer;
						transform: scale(1.1);
						transition: all 0.3s ease;
						
					}
					
					&-fenGeFu {
						width: 20px;
						height: 20px;
						background: url('../assets/img/label_FenGeFu.png');
						background-repeat: no-repeat;
						background-size: cover;
					}

					.content-nav-active {
						// background-color: #972326;
						color: #972326;
					}
				}

				.content-nav-item {
					width: 1056px;
					margin: 0 auto;
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
					//border: 1px solid blue;

					.item-list {
						width: 330px;
						height: 400px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						margin: 10px 10px;
						border: 1px solid #972326;
						border-radius: 10px;
						transition: all 0.3s ease;
						cursor: pointer;

						&:hover {
							border: 1px solid #fff;
							box-shadow: 0 0 5px 2px rgba(151, 35, 38, 0.4);
							transform: scale(1.05);
							transition: all 0.3s ease;
						}

						.item-img {
							width: 300px;
							height: 128px;
							border-radius: 5px;
							background-color: #f8f8f8;
							background-repeat: no-repeat;
							background-size: contain;
							background-position: center;
							background-origin: content-box;
						}

						&-title {
							width: 300px;
							height: 60px;
							color: #e13834;
							font-size: 22px;
							padding: 0 10px;
							margin: 20px 0;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							white-space: normal !important;
							word-wrap: break-word;
							// border-left: 1px solid #15669e;
						}

						&-content {
							width: 273px;
							height: 100px;
							font-size: 14px;
							color: gray;

							// 文本长度处理 begin
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 5;
							-webkit-box-orient: vertical;
							white-space: normal !important;
							word-wrap: break-word;
							// 文本长度处理 ending

						}

						&-more {
							width: 273px;
							padding-top: 20px;
							display: flex;
							justify-content: space-between;
							align-items: center;

							img {
								width: 12px;
								height: 12px;
							}

							span {
								color: #972326;
								padding: 0 5px;
							}
						}
					}
				}
			}
		}

		.text-decoration {
			text-decoration: none;
		}
	}
</style>